<template>
  <v-container>
    <v-row class="mb-5">
      <span class="mr-2">Добавить фильтр</span>
      <v-btn
        class="mr-2"
        small
        :disabled="isLoading"
        :loading="isLoading"
        @click="mixAddListItemItemHandler('where', $options.widgetItems)"
      >
        <v-icon small> mdi-plus </v-icon>
      </v-btn>
    </v-row>
    <v-row
      align="center"
      class="my-5"
      v-for="(listItemItem, listItemItemIndex) in listItem.data.where"
      :key="listItemItemIndex"
    >
      <v-col cols="2">
        <v-select
          outlined
          item-value="value"
          item-text="title"
          return-object
          hide-details
          dense
          :disabled="isLoading"
          :loading="isLoading"
          :value="listItemItem.data.field"
          :items="$options.fieldList"
          @input="updateWidgetField($event, listItemItemIndex)"
        />
      </v-col>
      <v-col cols="3" v-if="listItemItem.data.field !== null">
        <v-select
          outlined
          item-value="value"
          item-text="title"
          return-object
          hide-details
          dense
          :disabled="isLoading"
          :loading="isLoading"
          :value="listItemItem.data.condition"
          :items="listItemItem.data.field.conditions"
          @input="mixChangeListItemItemHandler($event, 'where', listItemItemIndex, 'condition')"
        />
      </v-col>
      <v-col cols="5" v-if="listItemItem.data.condition !== null">
        <component
          :is="listItemItem.data.field.component"
          :value="listItemItem.data.value"
          :entity="listItemItem.data.field.entityName"
          @input="mixChangeListItemItemHandler($event, 'where', listItemItemIndex, 'value')"
        />
      </v-col>
      <v-col cols="2">
        <v-btn
          small
          :disabled="isLoading"
          :loading="isLoading"
          @click="mixRemoveListItemItemHandler(listItemItemIndex, 'where')"
        >
          <v-icon color="red">mdi-trash-can-outline</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="3">
        <span>Количество</span>
        <v-text-field
          type="number"
          outlined
          hide-details
          dense
          :disabled="isLoading"
          :loading="isLoading"
          :value="listItem.data.limit"
          @input="mixChangeListItemHandler(Number($event), 'limit')"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="3">
        <span>Макет</span>
        <v-select
          outlined
          item-value="value"
          item-text="title"
          return-object
          hide-details
          dense
          :disabled="isLoading"
          :loading="isLoading"
          :value="listItem.data.layout"
          :items="$options.layoutsList"
          @change="mixChangeListItemHandler($event, 'layout')"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import dynamicListItemMix from '@/mixins/dynamic-list/dynamicListItem.mix.js'
import { widgetItems } from '@/utils/widgets/widgetsTypes.js'
import FeedWidgetField from '@/utils/widgets/FeedWidgetField.js'
import ValuesInWidgetInput from '@/components/dynamic-list-items/widgets/feeds/inputs/ValuesInWidgetInput.vue'
import RelationWidgetInput from '@/components/dynamic-list-items/widgets/feeds/inputs/RelationWidgetInput.vue'
import DateWidgetInput from '@/components/dynamic-list-items/widgets/feeds/inputs/DateWidgetInput.vue'
import layoutsList from '@/configs/layoutsList.js'
const fieldList = [
  new FeedWidgetField('Выбранные маршрушты', 'id', 'valuesIn', 'routes')
]
export default {
  name: 'RoutesFeedWidget',
  widgetItems,
  fieldList,
  layoutsList,
  mixins: [dynamicListItemMix],
  components: {
    ValuesInWidgetInput,
    RelationWidgetInput,
    DateWidgetInput
  },
  methods: {
    updateWidgetField (value, index) {
      this.mixChangeListItemItemHandler(value, 'where', index, 'field')
      this.mixChangeListItemItemHandler(null, 'where', index, 'condition')
    }
  }
}
</script>
